import { initContract } from '@ts-rest/core';
import { z } from 'zod';

const c = initContract();

const conversationStarterSchema = z.object({
  id: z.string(),
  title: z.string(),
  shortTitle: z.string().optional(),
  description: z.string(),
  content: z.string(),
  preferenceId: z.string().optional(),
});

const scopeEnum = z.enum(['global', 'tenant', 'user']);

const resolvedStartersSchema = z.object({
  starters: z.array(conversationStarterSchema),
  scope: scopeEnum,
  specialty: z.string().nullable(),
});

export const conversationStarterDefaultsContract = c.router(
  {
    resolveForUser: {
      method: 'GET',
      path: '/resolve',
      query: z.object({
        language: z.string().optional(),
      }),
      responses: {
        200: resolvedStartersSchema,
        404: z.object({ message: z.string() }),
      },
      summary:
        'Resolve conversation starter defaults for a user (user > tenant > global)',
    },
  },
  {
    pathPrefix: '/:tenantId/conversation-starter-defaults',
  },
);
